import React, {useCallback, useEffect, useRef, useState} from 'react';

import {Icon, Icons} from '@pb/kit-component-icon';
import {Input} from '@pb/kit-component-input-v2';

import {provisioningClear, provisioningSearch, provisioningSearchIcons} from './provisioning-history.module.styl';

type Props = {value: string, onChange: (value: string) => void};

export const EmailFilter = ({value, onChange}: Props) => {
    const [draft, setDraft] = useState(value);
    const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
    const cancel = useCallback(() => clearTimeout(timer.current), []);

    useEffect(() => {
        cancel();
        setDraft(value);
        return cancel;
    }, [value, cancel]);

    const commit = () => {
        cancel();
        onChange(draft);
    };

    const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
        const next = event.currentTarget.value;
        setDraft(next);
        cancel();
        timer.current = setTimeout(() => onChange(next), 1000);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            commit();
        }
    };

    const handleClear = () => {
        cancel();
        setDraft('');
        onChange('');
    };

    return (
        <div className={provisioningSearch}>
            <Input
                id="provisioning-history-email"
                value={draft}
                placeholder="Search by email"
                aria-label="Search by email"
                aria-describedby="provisioning-history-email-hint"
                autoComplete="off"
                onInput={handleInput}
                onBlur={commit}
                onKeyDown={handleKeyDown}
                endAdornment={(
                    <span className={provisioningSearchIcons}>
                        {!!draft && (
                            <button
                                type="button"
                                aria-label="Clear email"
                                className={provisioningClear}
                                onMouseDown={event => event.preventDefault()}
                                onClick={handleClear}>
                                <Icon type={Icons.CLOSE} size="Size_19"/>
                            </button>
                        )}
                        <Icon type={Icons.SEARCH} size="Size_14"/>
                    </span>
                )}
            />
        </div>
    );
};
